import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { Compass, Sparkles, Library, Settings, Globe2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  const tabs = [
    { icon: Compass, label: language === 'tr' ? 'Ana Sayfa' : 'Home', path: '/dashboard' },
    { icon: Globe2, label: 'Orbit', path: '/orbit' },
    { icon: Sparkles, label: language === 'tr' ? 'Navigatör' : 'Navigator', path: '/coaching' },
    { icon: Library, label: 'INN', path: '/inn' },
    { icon: Settings, label: language === 'tr' ? 'Ayarlar' : 'Settings', path: '/settings' },
  ];

  return (
    <motion.nav
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="lg:hidden fixed bottom-0 left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-white/10 z-50"
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 40px)' }}
    >
      <div className="flex justify-around items-center py-3">
        {tabs.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center py-2 px-4 rounded-xl transition-all ${
                isActive 
                  ? 'text-[#D4AF37]' 
                  : 'text-[#6B7280] hover:text-[#D4AF37]'
              }`}
              data-testid={`mobile-tab-${item.path.slice(1)}`}
            >
              <item.icon className={`w-6 h-6 ${isActive ? 'text-[#D4AF37]' : ''}`} />
              <span className="text-xs mt-1 font-sans">{item.label}</span>
            </button>
          );
        })}
      </div>
    </motion.nav>
  );
};

export default BottomNav;
